// src/features/release-notes/useReleaseNoteActions.ts

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { manualSectionTarget } from '@/features/manual/utils/labels';
import { screenRoute } from './routes';
import type { ReleaseNote } from './types';

/** Navigation of a note's two links; `before` runs first (the dialog acknowledges there). */
export const useReleaseNoteActions = (before?: () => void) => {
  const navigate = useNavigate();

  const openScreen = useCallback(
    (note: ReleaseNote) => {
      const route = screenRoute(note.screen);
      if (!route) return;
      before?.();
      navigate(route);
    },
    [before, navigate]
  );

  const openManual = useCallback(
    (note: ReleaseNote) => {
      if (!note.manualChapter) return;
      before?.();
      const { to, state } = manualSectionTarget(note.manualChapter, note.manualAnchor);
      navigate(to, { state });
    },
    [before, navigate]
  );

  return { openScreen, openManual };
};
